/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since  2017.5.20
 * todo  用canvas完成重绘
 */
import "../utils/draggable";
let { Layer, Tooltip, setOptions, DivOverlay, DomUtil } = L;
let { requestAnimFrame } = L.Util;
let $ = T;
//
/**
 * todo 修整
 */
let TooltipCanvas = L.Canvas.extend({
  /**
   * 
   */
  getEvents() {
    var events = L.Renderer.prototype.getEvents.call(this);
    events.viewprereset = this._onViewPreReset;
    events.zoomstart = this._onZoomStart;
    return events;
  },
  /**
   * 
   */
  _onZoomStart() {
    this._update();
  },
  /**
   * 
   * @param {*} tooltip 
   */
  _updateTooltip(tooltip) {
    if (tooltip.isOpen() === false) {
      return;
    }
    let that = this;
    let { _ctx: ctx } = that;
    let p = that._map.latLngToLayerPoint(tooltip._latlng);
    let { options } = tooltip;
    let { offset, direction } = options;
    let [offsetX, offsetY] = offset;
    let { x, y } = p;
    let { clientWidth: width, clientHeight: height } = tooltip._container;
    let tw = 6;
    // 加大三角缺口
    if ((direction === 'top' || direction === 'bottom') && Math.abs(offsetX / offsetY) > 1 && Math.abs(offsetX / offsetY) < 10 && (Math.abs(offsetX) > 5 || Math.abs(offsetY) > 5)) {
      tw += Math.floor(Math.abs(offsetX / offsetY)) * 3;
    }
    // draw Text
    ctx.beginPath();
    ctx.lineWidth = options.border || 1;
    ctx.strokeStyle = options.strokeColor || '#fff';
    ctx.fillStyle = options.fillColor || '#fff';
    ctx.moveTo(x, y);
    //
    x += offsetX;
    y += offsetY;
    //
    let lineTo = (x, y) => {
      ctx.lineTo(x, y);
    }
    let padding = 6;
    if (options.border > 1) {
      let len = (options.border - 1) * 2;
      width += len;
      height += len;
      padding += options.border;
    }
    //
    switch (direction) {
      case 'left':
        x -= padding;
        lineTo(x, y - tw);
        lineTo(x, y - height / 2);
        lineTo(x - width, y - height / 2);
        lineTo(x - width, y + height / 2);
        lineTo(x, y + height / 2);
        lineTo(x, y + tw);
        break;
      case 'right':
        x += padding;
        lineTo(x, y - tw);
        lineTo(x, y - height / 2);
        lineTo(x + width, y - height / 2);
        lineTo(x + width, y + height / 2);
        lineTo(x, y + height / 2);
        lineTo(x, y + tw);
        break;
      case 'bottom':
        y += padding;
        lineTo(x - tw, y);
        lineTo(x - width / 2, y);
        lineTo(x - width / 2, y + height);
        lineTo(x + width / 2, y + height);
        lineTo(x + width / 2, y);
        lineTo(x + tw, y);
        break;
      case 'top':
      default:
        y -= padding;//.leaflet-tooltip-top { margin-top: -6px;}
        lineTo(x - tw, y);
        lineTo(x - width / 2, y);
        lineTo(x - width / 2, y - height);
        lineTo(x + width / 2, y - height);
        lineTo(x + width / 2, y);
        lineTo(x + tw, y);
        break;
    }
    ctx.lineTo(p.x, p.y);
    ctx.fill();
    ctx.stroke();
  }
})

//
let { _initLayout, onRemove, _setPosition } = Tooltip.prototype;
let tooltipRenderer;
Tooltip.include({
  /**
   * @override  点击-不关闭
   */
  getEvents: function () {
    let events = DivOverlay.prototype.getEvents.call(this);
    if (this.options.closeOnClick) {
      events.preclick = this._close;
    }
    // if (this.options.keepInView) {
    //     events.moveend = this._adjustPan;
    // } 
    return events
  },
  /**
   * @override
   */
  _setPosition: function (pos) {
    let { offset } = this._source.options
    offset && (pos = pos.add(offset))
    _setPosition.call(this, pos)
  },
  /**
   * @override
   */
  _initLayout: function () {
    let { options } = this;
    _initLayout.call(this);// 初始化
    let { offset, draggable, width, style } = options;
    let [offsetX, offsetY] = offset;
    let { _container: container } = this;
    style && T(container).setStyle(style)
    if (draggable) {
      // container.contentEditable = true;
      container.style.pointerEvents = 'auto';
      container.style.outline = '';
      let action = T(container).draggable();
      action.on('dragstart', e => {
        this._map.dragging.disable();
      }).on('drag', e => {
        let { clientWidth: width, clientHeight: height } = container;
        let mx = width / 2 + 6;
        let my = height / 2 + 6;
        // let { removeClass, addClass } = L.DomUtil;
        let { options } = this;
        let { offset } = options;
        // 改变offset，不能在原对象上直接改变，因为可能会共用同一个offset来生成Tooltip;
        offset = options.offset = [offset[0] + e.offsetX, offset[1] + e.offsetY];
        let [x, y] = offset;
        let { direction } = options;
        let from = direction;
        switch (from) {
          case 'top':
            y -= my;
            break;
          case 'bottom':
            y += my;
            break;
          case 'right':
            x += mx;
            break;
          case 'left':
            x -= mx;
            break;
        }
        if (y >= Math.abs(x)) {
          direction = 'bottom';
          y -= my;
        } else if (x > Math.abs(y)) {
          direction = 'right';
          x -= mx;
        } else if ((-x) > Math.abs(y)) {
          direction = 'left';
          x += mx;
        } else {
          direction = 'top';
          y += my;
        }
        if (from !== direction) {
          options.offset = [x, y];
          options.direction = direction;
          this._updatePosition();
        }
        //
        requestAnimFrame(tooltipRenderer._update, tooltipRenderer);
        requestAnimFrame(tooltipRenderer._redraw, tooltipRenderer)
      }).on('dragstop', e => {
        this._map.dragging.enable();
      })
    }
    // white-space:pre-line;width:80px;
    if (width > 0) {
      let { style } = container;
      style.wordBreak = 'break-all';
      style.wordWrap = 'break-word';
      style.whiteSpace = 'pre-wrap';
      style.width = width + 'px';
    }
    if (this._map && (draggable || (Math.abs(offsetX) > 5 || Math.abs(offsetY) > 5) && !options.pin)) {
      $(container).addClass('lake-leaflet-tooltip')
      if (!this._map.getPane('lake_tooltip_pane')) {
        T(this._map.createPane('lake_tooltip_pane')).setStyle({ zIndex: 399, pointerEvents: 'none' });//pointerEvents ie11+
        tooltipRenderer = new TooltipCanvas({ pane: 'lake_tooltip_pane' }).addTo(this._map);
      }
      let renderer = tooltipRenderer;
      renderer._initPath(this);
      renderer._addPath(this);
    }
  },
  /**
   * @override
   */
  _reset() {

  },
  /**
   * @override
   */
  _update() {

  },
  /**
   * @override
   */
  _project() {

  },
  /**
   * 
   * @param {*} map 
   */
  onRemove(map) {
    onRemove.call(this, map);
    if (tooltipRenderer) {
      requestAnimFrame(tooltipRenderer._update, tooltipRenderer);
      requestAnimFrame(tooltipRenderer._redraw, tooltipRenderer)
    }
  },
  /**
   * 
   */
  update() {
    DivOverlay.prototype.update.call(this);
    if (tooltipRenderer) {
      requestAnimFrame(tooltipRenderer._update, tooltipRenderer);
      requestAnimFrame(tooltipRenderer._redraw, tooltipRenderer)
    }
  },
  /**
   * 
   */
  _updatePath() {
    let renderer = tooltipRenderer
    renderer._updateTooltip(this);
  }

})
/**
 * 
 */
Layer.include({
  hideTooltip: function (hide) {
    let that = this;
    that._hideTooltip = hide;
    if (hide) {
      that.closeTooltip();
    } else {
      that.openTooltip();
    }
  },
  bindTooltip: function (content, options) {
    let that = this,
      { _tooltip, _map } = that;
    if (content instanceof Tooltip) {
      setOptions(content, options);
      that._tooltip = _tooltip = content;
      (content)._source = that;
    } else {
      if (!_tooltip || options) {
        that._tooltip = _tooltip = new Tooltip(options, that);
      }
      _tooltip.setContent(content);
    }
    that._initTooltipInteractions();
    options = _tooltip.options;
    if (_map && _map.hasLayer(that)) {
      let { zoom, minZoom, maxZoom, permanent } = options;
      zoom = options.zoom = minZoom || zoom;
      if (zoom) {
        zoom < _map._zoom && _map.getBounds().contains(that._latlng) && !that._hideTooltip && that.openTooltip();
      } else if (permanent) {
        !that._hideTooltip && that.openTooltip();
      }
    }
    return that;
  },
  closeTooltip: function (e) {
    let that = this,
      { _tooltip } = that;
    if (_tooltip) {
      let { options } = _tooltip;
      if (e && e.type !== 'remove') {
        let { _map } = that;
        if (e.target && _map && options.zoom < _map._zoom) {
          return;
        }
      }
      _tooltip._close();
      if (options.interactive && _tooltip._container) {
        DomUtil.removeClass(_tooltip._container, 'leaflet-clickable');
        that.removeInteractiveTarget(_tooltip._container);
      }
    }
    return that;
  },
  _openTooltip: function (e) {
    let that = this;
    let layer = e.layer || e.target;
    let { _tooltip, _map, _latlng } = that;
    if (!_tooltip || !_map || _tooltip.isOpen()) {
      return;
    }
    !that._hideTooltip && that.openTooltip(layer, _tooltip.options.sticky ? e.latlng : undefined);
  }
});


// WEBPACK FOOTER //
// ./src/polyfill/ToolTip.js